import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FilePreviewService} from '../../../services/ui/file-preview.service';
import {UploadedFileInfo} from '../../../models/ui/uploaded-file-info.class';
import {BaseComponent} from '../../base/base.component';
import {isNil} from 'lodash';
import {FileUpload} from 'primeng';
import {switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss'],
  providers: [
    FilePreviewService,
  ]
})
export class FilePreviewComponent extends BaseComponent {

  private _entityClass: string;
  private _entityId: any;
  private _appModule: string;

  @ViewChild('fileUploader', { static: false })
  fileUploader: FileUpload;

  fileList: UploadedFileInfo[] = [];
  selectedFile: UploadedFileInfo = null;

  viewerOptions: any = {
    inline: false,
    keyboard: true,
    navbar: false,
    toolbar: false,
    button: false,
    fullscreen: false,
    loop: false,
    scalable: false,
    rotatable: false,
    title: false,
    initialCoverage: 1
  };

  @Input()
  set entityClass(val: string) {
    this._entityClass = val;
    this.loadFiles();
  }

  @Input()
  set entityId(val: any) {
    this._entityId = val;
    this.loadFiles();
  }

  @Input()
  set appModule(val: any) {
    this._appModule = val;
    this.loadFiles();
  }

  constructor(private filePreviewScv: FilePreviewService) {
    super();
  }

  ngOnInit() {
    this.loadFiles();
  }

  private loadFiles() {
    if ((!isNil(this._entityClass) && this._entityClass.length > 0) && !isNil(this._entityId) &&
        (!isNil(this._appModule) && this._appModule.length > 0)) {
      this.filePreviewScv.pathForEntity(this._entityClass, this._entityId, this._appModule)
          .pipe(switchMap(path => this.filePreviewScv.list(path, this._appModule))).subscribe({
        next: flist => {
          this.fileList = flist;
          if (this.fileList.length > 0) {
            if (this._entityClass === 'Company') {
              const logoFile = this.fileList.find(f => f.fileName.toLowerCase().indexOf('logo') !== -1);
              if (logoFile) {
                this.selectFile(logoFile);
              } else {
                this.selectFile(this.fileList[0]);
              }
            } else {
              this.selectFile(this.fileList[0]);
            }
          } else {
            this.selectedFile = null;
          }
        },
        error: err => this.setError(err),
      });
    } else {
      this.fileList = [];
      this.selectedFile = null;
    }
  }

  get isPdf(): boolean {
    if (!isNil(this.selectedFile)) {
      return this.selectedFile.mimeType.indexOf('pdf') !== -1;
    }
    return false;
  }

  get isImage(): boolean {
    if (!isNil(this.selectedFile)) {
      return this.selectedFile.mimeType.indexOf('image') !== -1;
    }
    return false;
  }

  private selectFile(file: UploadedFileInfo) {
    this.selectedFile = file;
    this.filePreviewScv.getFile(file, this._appModule).subscribe({
      next: info => {
        this.selectedFile.data = info.data;
        this.selectedFile.url = info.url;
        this.selectedFile.safeUrl = info.safeUrl;
        // console.log(info.url);
      },
      error: err => {
        this.setError(err);
      }
    });
  }

  onSelectFile(file: UploadedFileInfo) {
    this.selectFile(file);
  }

  onRemoveFile(file: UploadedFileInfo) {
    this.filePreviewScv.remove(file.path, this._appModule).subscribe({
      next: flist => {
        const idx = this.fileList.findIndex(f => f.path === file.path);
        if (idx > -1) {
          this.fileList.splice(idx, 1);
          if (this.fileList.length > 0) {
            this.selectFile(this.fileList[0]);
          } else {
            this.selectedFile = null;
          }
        }
      },
      error: err => this.setError(err),
    });
  }

  uploadHandler(event: any) {
    this.filePreviewScv.pathForEntity(this._entityClass, this._entityId, this._appModule)
        .pipe(switchMap(path => this.filePreviewScv.upload(path, event.files[0], this._appModule))).subscribe({
      next: info => {
        this.fileList.push(info);
        this.fileList = [...this.fileList];
        this.fileUploader.clear();
        if (this.fileList.length === 1) {
          this.selectFile(this.fileList[0]);
        }
        if (this._entityClass === 'Company') {
          this.loadFiles();
        }

      },
      error: err => this.setError(err),
    });
  }
}
